import React from "react";
import "./Pagination.css";

const Pagination = ({ totalHeaders, currentHeader, setCurrentHeader, headers }) => {

  return (
    <div className="pagination-container">

      <div className="slide-number">
        {String(currentHeader.id + 1).padStart(2, "0")}<span className="slide-total">/0{totalHeaders}</span>
      </div>

      <div className="line"></div>

      <div className="dots">
        {Array.from({ length: totalHeaders }, (_, i) => (
          <span
            key={i}
            className={`dot ${currentHeader.id === i ? "active" : ""}`}
            onClick={() => setCurrentHeader(headers[i])}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Pagination;